import React from "react"
import * as styles from "./switcherTextBlock.module.scss"

export const data = [
  {
    text: "Список документов Заемщика для рассмотрения заявки на кредит",
    href: "https://scb.ru/client-api/documents/8972",
  },
  {
    text: "Документы для рассмотрения заявления на кредит по Продавцу и Объекту недвижимости",
    href: "https://scb.ru/client-api/documents/8971",
  },
  {
    text: "Список дополнительных документов для рассмотрения заявки при рефинансировании ипотечного кредита",
    href: "https://scb.ru/client-api/documents/8973",
  },
]

export const RequirementsRefin = () => (
  <div className={styles.htmlBlock}>
    <ul>
      <li>Паспорт РФ;</li>
      <li>Возраст от 18 до 75 лет;</li>
      <li>
        Официальное трудоустройство (стаж на&nbsp;последнем месте работы не&nbsp;менее
        4&nbsp;месяцев);
      </li>
      <li>
        Наличие постоянной регистрации не&nbsp;менее 4&nbsp;последних месяцев на&nbsp;территории
        одного населенного пункта РФ, проживание в&nbsp;городе присутствия подразделения Банка
        или&nbsp;в&nbsp;одном из&nbsp;прилегающих населенных пунктов (но&nbsp;не&nbsp;более
        70&nbsp;километров от&nbsp;любого внутреннего структурного подразделения Банка).
      </li>
    </ul>
  </div>
)
